module.exports = __webpack_public_path__ + "img/pr-3.e471ec1f.png";